module.exports = __webpack_public_path__ + "static/media/backgroundhome.bd1ac759.jpg";